// cutiefunny/musclecat-studio/musclecat-studio-1e58aa6ff05d2d0c24e0d313fcd9602693ca1d8a/app/page.js
'use client';

import { useState, useEffect } from 'react';
import Link from 'next/link';
import styles from "./page.module.css";
import Image from 'next/image';
import { db } from '@/lib/firebase/clientApp';
// [수정] doc, getDoc, setDoc, increment 추가
import { collection, query, orderBy, limit, getDocs, doc, getDoc, setDoc, increment } from 'firebase/firestore';
import { FaPhone, FaEnvelope, FaInstagram } from 'react-icons/fa';

// --- Swiper Import ---
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
// --- Swiper Import End ---

// --- 데이터 Import ---
import { projects as allProjects } from '@/data/projects'; // 포트폴리오 슬라이더용
import { goodsItems as allGoodsItems } from '@/data/goods'; // 굿즈 데이터 가져오기
// ⬇️ (추가) 새 엔터테인먼트 데이터 임포트
import { entertainmentItems as allEntertainmentItems } from '@/data/entertainment'; 
// --- 데이터 Import End ---


export default function Home() {
  const [latestNews, setLatestNews] = useState([]);
  const [shuffledPortfolioImages, setShuffledPortfolioImages] = useState([]);
  const [displayedGoods, setDisplayedGoods] = useState([]); 
  const [mobileGoodsIndex, setMobileGoodsIndex] = useState(0); 

  // --- 엔터테인먼트 섹션용 상태 (유지) ---
  const [displayedEntertainment, setDisplayedEntertainment] = useState([]);
  const [mobileEntertainmentIndex, setMobileEntertainmentIndex] = useState(0);
  // --- 엔터테인먼트 상태 끝 ---

  // [추가] 방문자 수 상태
  const [visitorCount, setVisitorCount] = useState(null);


  useEffect(() => {
    // --- 포트폴리오 이미지 셔플 ---
    // ⬇️ (수정) allProjects에서 portfolioImageUrls 추출
    const portfolioImageUrls = allProjects.map(p => p.imageUrl);
    const shuffledPortfolios = [...portfolioImageUrls].sort(() => Math.random() - 0.5); 
    setShuffledPortfolioImages(shuffledPortfolios);

    // --- 최신 굿즈 설정 로직 (랜덤 3개 선택) ---
    const shuffledGoods = [...allGoodsItems].sort(() => Math.random() - 0.5);
    setDisplayedGoods(shuffledGoods.slice(0, 3));
    
    // --- ⬇️ UPDATED: 엔터테인먼트 데이터 설정 (랜덤 3개 선택으로 수정) ---
    // data/entertainment.js에서 가져온 데이터를 섞고 상위 3개 선택
    const shuffledEntertainment = [...allEntertainmentItems].sort(() => Math.random() - 0.5);
    setDisplayedEntertainment(shuffledEntertainment.slice(0, 3));
    // --- 엔터테인먼트 데이터 설정 끝 ---


    // Fetch latest news
    const fetchLatestNews = async () => {
      try {
        const newsCollection = collection(db, 'news');
        const q = query(newsCollection, orderBy('timestamp', 'desc'), limit(3));
        const newsSnapshot = await getDocs(q);
        const newsList = newsSnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
        setLatestNews(newsList);
      } catch (error) {
        console.error("최신 뉴스를 불러오는 중 오류 발생:", error);
      }
    };

    // [추가] 방문자 수 로드 및 증가 로직
    const fetchAndIncrementVisitorCount = async () => {
      // 경고: 'analytics/visitors' 경로는 가정된 값입니다.
      const visitorDocRef = doc(db, 'analytics', 'visitors'); 
      const visitKey = 'visitCountedDate';
      const today = new Date().toISOString().split('T')[0];

      try {
        // 1. 현재 방문자 수 먼저 가져오기
        const docSnap = await getDoc(visitorDocRef);
        let currentCount = 0;
        if (docSnap.exists()) {
          currentCount = docSnap.data().total;
          setVisitorCount(currentCount);
        } else {
          setVisitorCount(0); // 문서가 없으면 0부터 시작
        }

        // 2. 오늘 방문했는지 확인하고, 안 했으면 카운트 증가
        if (localStorage.getItem(visitKey) !== today) {
          // 문서가 없으면 생성하고, 있으면 { merge: true }로 병합, increment(1)로 1 증가
          await setDoc(visitorDocRef, { total: increment(1) }, { merge: true });
          localStorage.setItem(visitKey, today);
          
          // 화면에 즉시 반영
          setVisitorCount(currentCount + 1);
        }
      } catch (error) {
        console.error("방문자 수 처리 중 오류 발생:", error);
        // 오류가 발생해도 페이지 로드는 계속되도록 함
      }
    };

    fetchLatestNews();
    fetchAndIncrementVisitorCount(); // [추가] 함수 호출
  }, []); 

  // --- 모바일 굿즈 순환 로직 (유지) ---
  useEffect(() => {
    if (displayedGoods.length > 0) {
      const intervalId = setInterval(() => {
        setMobileGoodsIndex((prevIndex) => (prevIndex + 1) % displayedGoods.length);
      }, 5000); 
      return () => clearInterval(intervalId);
    }
  }, [displayedGoods]);
  
  // --- 모바일 엔터테인먼트 순환 로직 (유지) ---
  useEffect(() => {
    if (displayedEntertainment.length > 0) {
      const intervalId = setInterval(() => {
        setMobileEntertainmentIndex((prevIndex) => (prevIndex + 1) % displayedEntertainment.length);
      }, 5000); 
      return () => clearInterval(intervalId);
    }
  }, [displayedEntertainment]);
  

  return (
    <div className={styles.page}>
      {/* [추가] 방문자 수 카운터 */}
      {visitorCount !== null && (
        <div className={styles.visitorCounter}>
          total {visitorCount.toLocaleString()}
        </div>
      )}

      {/* 타이틀 이미지 */}
      <Image src="/images/title.png" alt="근육고양이 스튜디오" width={500} height={300} style={{ width: '350px', height: 'auto' }} priority />

      <div className={styles.buttonContainer}>
        {/* 뉴스 버튼 */}
        <Link href="/news">
          <Image src="/images/news-button.png" alt="뉴스 보러가기" width={200} height={80} style={{ width: 'auto', height: '50px' }} />
        </Link>

        {/* 최신 뉴스 표시 */}
        <div className={styles.latestNewsContainer}>
          {latestNews.length > 0 ? latestNews.map(news => (
            <Link href={`/news#${news.id}`} key={news.id} className={styles.newsItemLink}>
              <div className={styles.newsItem}>
                {news.imageUrl && (
                  <div className={styles.newsImageContainer}>
                    <Image
                      src={news.imageUrl}
                      alt="뉴스 이미지"
                      width={300}
                      height={300}
                      className={styles.newsImage}
                    />
                  </div>
                )}
                <div className={styles.newsContent}>
                    <p className={styles.newsText}>{news.text}</p>
                    <span className={styles.newsDate}>
                    {news.timestamp ? new Date(news.timestamp.toDate()).toLocaleDateString() : ''}
                    </span>
                </div>
              </div>
            </Link>
          )) : <p className={styles.noNews}>새로운 소식이 없습니다.</p>}
        </div>

        {/* 포트폴리오 버튼 */}
        <Link href="/portfolio">
          <Image src="/images/portfolio-button.png" alt="포트폴리오 보러가기" width={200} height={80} style={{ width: 'auto', height: '50px' }} />
        </Link>

        {/* 포트폴리오 이미지 슬라이더 */}
        <div className={styles.portfolioSliderContainer}>
          <Swiper
            modules={[Navigation, Pagination, Autoplay]}
            spaceBetween={10}
            slidesPerView={1}
            loop={true}
            autoplay={{
              delay: 3000,
              disableOnInteraction: false,
            }}
            pagination={{ clickable: true }}
            breakpoints={{
              640: {
                slidesPerView: 3,
                spaceBetween: 15,
              },
              1024: {
                slidesPerView: 3,
                spaceBetween: 20,
              },
            }}
            className={styles.portfolioSwiper}
          >
            {shuffledPortfolioImages.map((imageUrl, index) => (
              <SwiperSlide key={index} className={styles.portfolioSlide}>
                <Image
                  src={imageUrl}
                  alt={`포트폴리오 이미지 ${index + 1}`}
                  width={300}
                  height={200}
                  className={styles.portfolioImage}
                  loading="lazy"
                />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>

        {/* --- 엔터테인먼트 섹션 (유지) --- */}
        <Link href="/entertainment"> 
          <Image src="/images/enter-button.png" alt="엔터테인먼트 보러가기" width={200} height={80} style={{ width: 'auto', height: '50px' }} />
        </Link>

        {/* (수정 없음) displayedEntertainment 배열 자체가 최대 3개이므로 렌더링 로직은 동일 */}
        <div className={styles.latestGoodsContainer}>
          {displayedEntertainment.length > 0 ? displayedEntertainment.map((item, index) => (
            <Link
              href={item.link}
              key={item.id}
              className={`${styles.goodsItemLink} ${styles.desktopGoodsItem} ${index === mobileEntertainmentIndex ? styles.mobileVisibleGoodsItem : styles.mobileHiddenGoodsItem}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className={styles.goodsItem}>
                {item.imageUrl && (
                  <div className={styles.goodsImageContainer}>
                    <Image
                      src={item.imageUrl}
                      alt={item.name}
                      width={300}
                      height={300}
                      className={styles.goodsImage}
                    />
                  </div>
                )}
                <div className={styles.goodsContent}>
                  <h4 className={styles.goodsName}>{item.name}</h4>
                  {/* <p className={styles.goodsPrice}>{item.description}</p> */}
                </div>
              </div>
            </Link>
          )) : <p className={styles.noGoods}>엔터테인먼트가 없습니다.</p>}
        </div>
        {/* --- 엔터테인먼트 섹션 끝 --- */}


        {/* 굿즈 버튼 */}
        <Link href="/goods">
          <Image src="/images/goods-button.png" alt="굿즈 보러가기" width={200} height={80} style={{ width: 'auto', height: '50px' }} />
        </Link>

        {/* 최신 굿즈 표시 섹션 */}
        {/* (수정 없음) displayedGoods 배열 자체가 최대 3개이므로 렌더링 로직은 동일 */}
        <div className={styles.latestGoodsContainer}>
          {displayedGoods.length > 0 ? displayedGoods.map((item, index) => (
            <Link
              href={item.link}
              key={item.id}
              className={`${styles.goodsItemLink} ${styles.desktopGoodsItem} ${index === mobileGoodsIndex ? styles.mobileVisibleGoodsItem : styles.mobileHiddenGoodsItem}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className={styles.goodsItem}>
                {item.imageUrl && (
                  <div className={styles.goodsImageContainer}>
                    <Image
                      src={item.imageUrl}
                      alt={item.name}
                      width={300}
                      height={300}
                      className={styles.goodsImage}
                    />
                  </div>
                )}
                <div className={styles.goodsContent}>
                  <h4 className={styles.goodsName}>{item.name}</h4>
                  <p className={styles.goodsPrice}>{item.price}</p>
                </div>
              </div>
            </Link>
          )) : <p className={styles.noGoods}>판매 중인 상품이 없습니다.</p>}
        </div>
        {/* --- 최신 굿즈 표시 섹션 끝 --- */}


        {/* 문의하기 버튼 */}
        <Link href="/contact">
          <Image src="/images/contact-button.png" alt="문의하기" width={200} height={80} style={{ width: 'auto', height: '50px' }} />
        </Link>

        {/* 연락처 정보 */}
        <div className={styles.contactInfoHome}>
          <div className={styles.infoItem}>
              <FaPhone className={styles.icon} />
              <a href="tel:010-8315-1379">010-8315-1379</a>
            </div>
            <div className={styles.infoItem}>
              <FaEnvelope className={styles.icon} />
              <a href="mailto:cutiefunny@naver.com">cutiefunny@naver.com</a>
            </div>
            <div className={styles.infoItem}>
              <FaInstagram className={styles.icon} />
              <a href="https://instagram.com/musclecat_mart" target="_blank" rel="noopener noreferrer">@musclecat_mart</a>
            </div>
        </div>
      </div>

      {/* --- Footer --- */}
      <footer className={styles.footer}>
        <div className={styles.footerInfo}>
            <span>상호: 근육고양이 스튜디오</span>
            <span>대표: 김준환</span>
            <span>사업자등록번호: 421-22-02624</span>
        </div>
        <div className={styles.footerInfo}>
             <span>주소: 서울특별시 마포구 독막로15길19 (상수동)</span>
        </div>
        <div className={styles.footerInfo}>
             <span>Tel: 010-8315-1379</span>
            <span>Email: cutiefunny@naver.com</span>
        </div>
        <div className={styles.footerInfo}>
          <span>© 2025 MuscleCat Studio. All rights reserved.</span>
        </div>
      </footer>
       {/* --- Footer 끝 --- */}
    </div>
  );
}